<template>
  <div>
    <div class="dialog-bg"></div>
    <div class="dialog-container">
      <div class="dialog-box">
        <p class="dialog-box-text">
          <i class="fa fa-exclamation-triangle has-text-warning dialog-box-text-icon"></i>
          <span v-if="lang_data">{{ localization("app-session-expired", "Session expired") }}</span>
        </p>
        <div class="buttons dialog-box-actions">
          <a class="button is-small" @click="$emit('close')" v-if="lang_data">{{ localization("app-cancel", "Cancel") }}</a>
          <a class="button is-small is-warning" @click="action_two" v-if="lang_data">{{ localization("app-refresh", "Refresh") }}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        appName: "CORE",
      };
    },
    created() {
      if (process.env.VUE_APP_ENV == "development") this.appName = "localhost:8080";
      else if (process.env.VUE_APP_ENV == "staging") this.appName = "core-stage.sensehawk.com";
      else this.appName = "core.sensehawk.com";
    },
    methods: {
      action_one() {
        if (process.env.VUE_APP_ENV == "development") window.open("http://localhost:8080", "_blank");
        else if (process.env.VUE_APP_ENV == "staging") window.open("https://core-stage.sensehawk.com", "_blank");
        else window.open("https://core.sensehawk.com", "_blank");
      },
      action_two() {
        this.$router.go();
      },
    },
  };
</script>
<style lang="scss">
  .dialog-bg {
    display: flex;
    justify-content: center;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: #d8d4d4;
    opacity: 0.6;
    z-index: 100000;
  }

  .dialog-container {
    display: flex;
    justify-content: center;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 100001;
    .dialog-box {
      border-radius: 10px;
      margin-top: 1.5rem;
      height: max-content;
      display: flex;
      background: black;
      color: white;
      padding: 0.75rem;
      .dialog-box-text {
        margin-right: 1rem;
        &-icon {
          margin-right: 0.5rem;
        }
      }
    }
  }
</style>
